import { useContext } from 'react';
import { AddInsuranceModalContext } from '../shared/modal/AddInsuranceModalContextProvider';

const useAddInsuranceModalContext = () => {
  const context = useContext(AddInsuranceModalContext);
  return context;
};

export default useAddInsuranceModalContext;
